(function () {

    "use strict";

    console.log("Review Generator Loaded");

    if (!window.REVIEW_DATA) {

        console.error("REVIEW_DATA not found.");

        return;

    }

    const data = window.REVIEW_DATA;

    // ============================================
// Get Product ID
// ============================================

const productElement = document.querySelector(
    "[data-product-id]"
);

const productId = productElement
    ? parseInt(productElement.dataset.productId, 10)
    : 1;


// ============================================
// Seeded Random
// ============================================

function mulberry32(seed) {

    return function () {

        let t = seed += 0x6D2B79F5;

        t = Math.imul(
            t ^ t >>> 15,
            t | 1
        );

        t ^= t + Math.imul(
            t ^ t >>> 7,
            t | 61
        );

        return (
            (t ^ t >>> 14) >>> 0
        ) / 4294967296;

    };

}

            const random = mulberry32(productId);
            const summary =
                ANKUR_REVIEW_ENGINE.getSummary(productId);

            const TOTAL_REVIEWS =
                summary.count;

            // ============================================
            // Generated Review Count
            // ============================================

            
            console.log(
                "Generated Reviews:",
                TOTAL_REVIEWS
            );

    const generated = [];

    function randomItem(array) {

        return array[
            Math.floor(random() * array.length)
        ];

    }

    function randomReview(rating) {
            // Negative generated reviews only
            // Do not touch TrustShop merged data

            if (
                rating === 1 &&
                Array.isArray(data.negativeReviews)
            ) {

                const severity1 = data.negativeReviews.filter(
                    review => review.severity === 1
                );

                if (severity1.length) {
                    return randomItem(severity1).text;
                }

            }


            if (
                rating === 2 &&
                Array.isArray(data.negativeReviews)
            ) {

                const severity2 = data.negativeReviews.filter(
                    review => review.severity === 2
                );

                if (severity2.length) {
                    return randomItem(severity2).text;
                }

            }


            // Existing positive review system remains untouched
            const libraries = [

            data.longEnglishReviews,
            data.englishReviews,
            data.shortReviews,
            data.hinglishReviews,
            data.longHinglishReviews,
            data.hindiReviews,
            data.longHindiReviews

        ];

        const library = randomItem(libraries);

        return randomItem(library);

    }
    function getRating(totalReviews) {

    if (totalReviews <= 0) {

        return 0;

    }

    const seed = random();

    /*
    Products with only 1 review
    */

    if (totalReviews === 1) {

        if (seed < 0.60) return 5;
        if (seed < 0.80) return 4;
        if (seed < 0.90) return 3;
        if (seed < 0.97) return 2;

        return 1;

    }

    /*
    Products with 2 reviews
    */

    if (totalReviews === 2) {

        if (seed < 0.35) return 5;
        if (seed < 0.60) return 4;
        if (seed < 0.80) return 3;
        if (seed < 0.93) return 2;

        return 1;

    }

    /*
    Products having 3 or more reviews
    */

    if (seed < 0.20) return 5;
    if (seed < 0.40) return 4;
    if (seed < 0.60) return 3;
    if (seed < 0.80) return 2;

    return 1;

    }
    // ============================================
    // Dynamic Review Date Generator
    // ============================================

    function randomDate() {

        const today = new Date();

        // Generate date within last 365 days
        const daysAgo = Math.floor(random() * 365);

        const reviewDate = new Date(today);

        reviewDate.setDate(
            today.getDate() - daysAgo
        );

            const day = String(
            reviewDate.getDate()
            ).padStart(2, "0");


            const month = String(
                reviewDate.getMonth() + 1
            ).padStart(2, "0");


            const year = reviewDate.getFullYear();


            return `${day}/${month}/${year}`;

    }


// ============================================
// Generate Reviews
// ============================================
    for (let i = 0; i < TOTAL_REVIEWS; i++) {

        const firstName = randomItem(data.names);

        const lastName = randomItem(data.lastNames);

        const rating = 
            ANKUR_REVIEW_ENGINE.getReviewRating(
                productId,
                TOTAL_REVIEWS
            );

        generated.push({

            id: "ACR-" + (i + 1),

            name: firstName + " " + lastName,

            city: randomItem(data.cities),

            rating: rating,

            review: randomReview(rating),

            date: randomDate(),

            verified: true

        });

    }

    window.GENERATED_REVIEWS = generated;
    console.log("📢 Dispatching generated reviews event...");
    
    document.dispatchEvent(
    new CustomEvent("ankur:generated-reviews-ready")
    );

    console.log("Generated Reviews");

    console.table(window.GENERATED_REVIEWS);

})();